export const MY_DOMAINS_SHARED_COMPONENTS_TRANSLATIONS_NS = 'my-domains-shared-components-translations-ns';
export const resourceLoader = async (locale) => {
    return import(`./locale/messages_${locale}.json`);
};
//# sourceMappingURL=resourceLoader.js.map